"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _TransfersFiltersComponent = _interopRequireDefault(require("./TransfersFiltersComponent"));
var _reduxForm = require("redux-form");
var _reactRedux = require("react-redux");
var _paginationActions = require("../../../redux/actions/paginationActions");
var _transferActions = require("../../../redux/actions/transferActions");
var _transferRequestActions = require("../../../redux/actions/transferRequestActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var OMSId = state.user.userInfo.OMSId;
  var selectedAccountId = state.user.selectedAccountId;
  return {
    OMSId: OMSId,
    AccountId: selectedAccountId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getTransfers: function getTransfers(OMSId, accountId) {
      dispatch((0, _transferActions.getTransfers)(accountId));
      dispatch((0, _transferActions.getIncomingTransfers)(OMSId, accountId));
      dispatch((0, _transferRequestActions.getTransferRequestsReceived)(accountId, OMSId));
      dispatch((0, _transferRequestActions.getTransferRequestsRequested)(accountId, OMSId));
    },
    resetActivePage: function resetActivePage() {
      return dispatch((0, _paginationActions.setActivePage)({
        componentName: 'TransfersComponent',
        activePage: 0
      }));
    }
  };
};
var TransfersFiltersForm = (0, _reduxForm.reduxForm)({
  form: 'transfers-filters-form',
  initialValues: {
    transfersFilters: 'sentTransfers'
  }
})(_TransfersFiltersComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TransfersFiltersForm);